import React, { useEffect } from "react";
import "./Monthlyplans.css";
import AOS from "aos";
import "aos/dist/aos.css";
import WashFoldPlans from "./WashFoldPlans/WashFoldPlans";
import ShirtsMonthlyPlans from "./ShirtsMonthlyPlans/ShirtsMonthlyPlans";
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge, ListGroup } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

const monthlyPlans = "/sabmenu/1750755601.jpg"
export default function MonthlyPlans() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);


  const DirhamIcon = () => (
    <svg width="14" height="14" viewBox="0 0 100 100">
      <path
        d="M20 10 L20 90 Q80 90 80 50 Q80 10 20 10"
        stroke="white"
        strokeWidth="10"
        fill="none"
      />
      <line x1="20" y1="40" x2="100" y2="40" stroke="white" strokeWidth="10" />
      <line x1="20" y1="60" x2="100" y2="60" stroke="white" strokeWidth="10" />
    </svg>
  );
  return (
    <div className="">



      <section className="hero-section-freash-clean  pt-5 mt-5 position-relative overflow-hidden">
        <div className="hero-overlay-freash-clean py-5">
          <Container fluid="xl" className="py-5 mt-4 h-100">
            <Row className="align-items-center justify-content-center text-center h-100">
              <Col lg={8}>
                <h1 className="hero-title mb-4">
                  Fresh Clean Monthly Plans  <br />


                </h1>



                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                  <button className="suhedule-btn-dark"

                    onClick={() =>
                      window.open(
                        "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                        "_blank"
                      )
                    }>
                    Book Now
                  </button>

                  <button className="view-prices-list" onClick={() => navigate("/laundry-price")}>
                    VIEW PRICE LIST
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>


      <section className="monthly-section ">
        <div className="monthly-container mt-5">

          {/* LEFT IMAGE */}
          <div className="monthly-images">
            <div className="card-single">
              <img
                src={monthlyPlans}
                alt="5asecMonthly Plans"
              />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="monthly-content">
            <h2 className="expertise-title">Fresh Clean Monthly Plans</h2>

            <h4>Monthly Plans - Convenient, Easy, Affordable.</h4>

            <p>
              Pay monthly and simply book our contactless pick-up service whenever
              you’re ready.
            </p>

            <p className="vat-text">
              All prices are in <DirhamIcon /> and are exclusive of 5% VAT
            </p>
          </div>
        </div>
      </section>
      <div data-aos="fade-up">

        <WashFoldPlans />
      </div>
      <div data-aos="fade-up">

        <ShirtsMonthlyPlans />
      </div>


    </div>

  );
}
